import { Observable } from 'rxjs';

import { OrganizerCreateParams, OrganizerUpdateParams, Organizers } from '../models/organizer.model';

export abstract class OrganizerUsecase {
  abstract get organizers$(): Observable<Organizers>;

  abstract createOrganizer(params: OrganizerCreateParams): Observable<never>;
  abstract updateOrganizer(organizerId: string, params: OrganizerUpdateParams): Observable<never>;
  abstract deleteOrganizer(organizerId: string): Observable<never>;
  abstract deleteOrganizerTrackingDevices(organizerId: string): Observable<never>;
  abstract updateOrganizerRestriction(organizationId: string, enabled: boolean): Observable<never>;

  abstract reload(): void;
}
